<div #container [class.highlight]="$isHighlighted()">
  @let formInstance = $formInstance();
  <kendo-gridlayout [rows]="$rowConfig()" [cols]="$colConfig()" [align]="{ vertical: 'middle' }">
    <kendo-gridlayout-item>
      <h5>
        <unity-link-shared
          *unityAuthorizeForInternal="'FormInstance:View'; else elseBlock"
          [variants]="['boldblue']"
          [displayText]="$name()"
          [link]="['/agreement', formInstance.agreement.id, 'form-instance', formInstance.id]" />
        <ng-template #elseBlock> {{ $name() }}</ng-template>
      </h5>
    </kendo-gridlayout-item>
    <kendo-gridlayout-item>
      @if ((formInstance.is_draft || formInstance.is_untouched || formInstance.is_changes_requested) && formInstance.due_date) {
        <span class="label"><b>Due Date:</b></span>
        <span>{{ formInstance.due_date | dateTimezone: 'MM/dd/yyyy' }}</span>
        @if (formInstance.is_overdue) {
          <kendo-chip size="small" themeColor="error" class="overdue-chip">Overdue</kendo-chip>
        }
      }
      @if (!formInstance.is_draft && !formInstance.is_untouched && !formInstance.is_changes_requested) {
        <span class="label"><b>Submitted:</b></span>
        <span>{{ formInstance.last_submitted_date | dateTimezone: 'MM/dd/yyyy' }}</span>
      }
    </kendo-gridlayout-item>
    <kendo-gridlayout-item>
      @if (formInstance.is_untouched) {
        <unity-link-button-shared
          *unityAuthorize="'FormResponse:Create'"
          displayText="Fill Out Form"
          [link]="[
            '/agreement',
            formInstance.agreement.id,
            'form-schedule',
            formInstance.form_schedule.id,
            'form-instance',
            formInstance.id,
            'form',
            'create',
          ]" />
      } @else if (formInstance.is_draft) {
        <unity-link-button-shared
          *unityAuthorize="'FormResponse:Update'"
          displayText="Continue Draft"
          [link]="[
            '/agreement',
            formInstance.agreement.id,
            'form-instance',
            formInstance.id,
            'form-response',
            formInstance.form_response!.id,
          ]" />
      } @else if (formInstance.is_changes_requested) {
        <unity-link-button-shared
          *unityAuthorize="'FormResponse:Update'"
          displayText="Revise Form"
          [link]="[
            '/agreement',
            formInstance.agreement.id,
            'form-instance',
            formInstance.id,
            'form-response',
            formInstance.form_response!.id,
          ]" />
      } @else {
        <unity-link-button-shared
          *unityAuthorize="'FormInstance:Update'; else elseButtonBlock"
          displayText="View Form"
          [link]="[
            '/agreement',
            formInstance.agreement.id,
            'form-instance',
            formInstance.id,
            'form-response',
            formInstance.form_response!.id,
          ]" />
        <ng-template #elseButtonBlock>
          @if (formInstance.can_download_pdf) {
            <unity-button-download-shared
              buttonText="Download PDF"
              [disabled]="$isDownloading()"
              (clickEvent)="onClickDownload(formInstance)" />
          }
        </ng-template>
      }
    </kendo-gridlayout-item>
  </kendo-gridlayout>
</div>
